import { AudioEngine } from '../audio/AudioEngine';

export interface StateContext {
    engine: AudioEngine;
    transitionTo(state: PlayerState): void;
}

export abstract class PlayerState {
    constructor(protected readonly ctx: StateContext) {}

    abstract play(): void;
    abstract pause(): void;
    abstract stop(): void;
}

export class PausedState extends PlayerState {
    play(): void {
        this.ctx.transitionTo(new PlayingState(this.ctx));
        this.ctx.engine.play();
    }

    pause(): void {}

    stop(): void {
        this.ctx.transitionTo(new StoppedState(this.ctx));
        this.ctx.engine.stop();
    }
}

export class PlayingState extends PlayerState {
    play(): void {}

    pause(): void {
        this.ctx.transitionTo(new PausedState(this.ctx));
        this.ctx.engine.pause();
    }

    stop(): void {
        this.ctx.transitionTo(new StoppedState(this.ctx));
        this.ctx.engine.stop();
    }
}

export class StoppedState extends PlayerState {
    play(): void {
        this.ctx.transitionTo(new PlayingState(this.ctx));
        this.ctx.engine.play();
    }

    pause(): void {}

    stop(): void {}
}

export class LoadingState extends PlayerState {
    play(): void {
        this.ctx.transitionTo(new PlayingState(this.ctx));
        this.ctx.engine.play();
    }

    pause(): void {
        this.ctx.transitionTo(new PausedState(this.ctx));
        this.ctx.engine.pause();
    }

    stop(): void {}
}

export class ErrorState extends PlayerState {
    play(): void {}

    pause(): void {}

    stop(): void {}
}
